/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';
import { openModal, hideModal } from 'cards/actions/modalActions';
import FeatureFlags from '../../../../../util/featureFlags';
import { useSingleSampleLimitExhausted, useModalCloseCallback } from '../util/hooks';
import styles from './styles.module.less';

export const SingleSampleModalLinkBasePLP = ({ card, initialColor, showModal, closeModal }) => {
  const [sampleLimitExhausted, fetchSampleLimitExhausted] = useSingleSampleLimitExhausted(
    card.type
  );

  const preventClose = FeatureFlags.get('invitesSinglesampleSaveToDraftsOnExit');

  const closeCallback = useModalCloseCallback();

  if (
    (!FeatureFlags.get('invitesSingleSampleLimitScreen') && sampleLimitExhausted) ||
    !card.singleSampleAvailable ||
    (card.foil && !FeatureFlags.get('magnetFoilSingleSample'))
  ) {
    return null;
  }

  const originalModalOptions = {
    warnOnClose: !preventClose,
    preventClose,
    closeCallback,
  };

  function handleOpenModal(overrideProps = {}) {
    return showModal(
      {
        entryPoint: 'PLP',
        card,
        cardSuiteUUID: card.suiteUUID,
        initialColor,
        sampleLimitExhausted,
        fetchSampleLimitExhausted,
        handleOpenModal,
        closeModal,
        originalModalOptions,
        nonEditableSingleSampleSku: card.singleSampleSku,
        ...overrideProps,
      },
      originalModalOptions
    );
  }

  return (
    <div className={styles.linkBox}>
      <Link inline role="button" onClick={() => handleOpenModal()} arrow>
        Order A Free Sample
      </Link>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  showModal: (props, overrideOptions = {}) =>
    dispatch(
      openModal('SINGLE_SAMPLE_MODAL', props, {
        warnOnClose: true,
        bottomModalOnMobile: true,
        className: styles.modal,
        ...overrideOptions,
      })
    ),
  closeModal: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(SingleSampleModalLinkBasePLP);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleModalLinkPLP/SingleSampleModalLinkPLP.jsx